<template>
  <div>
    <check-input
      :value="value"
      @change="emitChange"
      :name="name"
    >
      <span>Я даю <a @click.stop.prevent="openModalPersonalData">согласие</a> на&nbsp;обработку персональных данных и&nbsp;подтверждаю ознакомление с&nbsp;<a @click.stop.prevent="openModalPrivacyPolicy">Политикой конфиденциальности</a> и&nbsp;<a href="/upload/docs/user_agreement.pdf" target="blank">Пользовательским соглашением</a></span>
    </check-input>

    <div v-if="error" class="check-input__error">Поле обязательно должно быть выбрано</div>

    <modal
      :show.sync="modalPersonalDataOpened"
      class="modal-info modal-personal-data"
      @modal:close="closeModalPersonalData"
    >
      <div class="modal-info__wrapper">
        <div class="form-scroll">
          <div class="form-scroll__content" data-scroll-lock-scrollable ref="modalPersonalData">
            <div class="sign-up-terms">
              <p class="sign-up-terms__title">Согласие на обработку персональных данных</p>
              <p class="sign-up-terms__text">
                Я подтверждаю, что являюсь <strong>совершеннолетним потребителем</strong> никотинсодержащей продукции, и добровольно, своей волей и в своем интересе, нажимая кнопку «Продолжить», я даю полное и безоговорочное согласие Обществу с ограниченной ответственностью «Дж.Т.И. Россия» (123112, Москва, проезд 1-й Красногвардейский, д. 15, этажи 28-32), далее – «Компания»,
              </p>
              <p class="sign-up-terms__text">
                на осуществление обработки с использованием средств автоматизации и/или без использования таких средств, в том числе с передачей данных по сетям связи общего доступа, включая сбор, запись, систематизация, хранение, уточнение (обновление, изменение), извлечение, использование, передача (предоставление, доступ), трансграничная передача, блокирование, удаление, уничтожение полученных от меня или от третьих лиц моих персональных данных,
              </p>
              <p class="sign-up-terms__text">
                <strong>с целью</strong> развития потребительского опыта при использовании продукции, взаимодействия с потребителями продукции, включая информирование пользователей продуктовых сайтов о деятельности и продукции Компании, проводимых активностях, что включает в себя регистрацию и проверку предоставленных конечными потребителями данных для доступа на сайты о продукции и к участию в программах, мероприятиях и активностях; составление статистической отчетности, аналитики данных об активностях потребителей для предоставления релевантной информации и повышения качества обслуживания, проведения опросов, исследований; организацию работы «Горячей линии», сервисов «Обратной связи»; взаимодействие с потребителями и направление информационных материалов о качественных характеристиках и потребительских свойствах продукции, программах, мероприятиях и активностях по любым каналам связи, включая, но не ограничиваясь,  направление смс-сообщений, сообщений по  электронной почте, передачу абонентам коротких текстовых сообщений, доступных для визуализации посредством использования программного обеспечения, установленного на их устройствах, в том числе всплывающих сообщений; обработку обращений потребителей; обеспечение работоспособности Сайта, в том числе с использованием информационных систем.
              </p>
              <p class="sign-up-terms__text">
                Я подтверждаю и гарантирую, что предоставленные мной персональные данные соответствуют действительности и являются актуальными, полными и точными, я уведомлен и согласен, что проверка моих персональных данных производится для подтверждения принадлежности мне указанных мной данных и моего совершеннолетия и не влечет доступ к другим моим персональным данным или обработку каких-либо других персональных данных.
              </p>
              <p class="sign-up-terms__text">
                Я соглашаюсь с тем, что Компания может передавать мои персональные данные третьим лицам для обработки и/или поручать обработку моих персональных данных третьим лицам в объеме, необходимом для достижения цели обработки, в том числе:
                <ul>
                <li>аффилированным лицам группы компаний JTI (в частности, головной компании JTI - JT International SA, (8, Рю Казем Раджави, 1202 Женева, Швейцария),</li>
                <li>лицам, привлекаемым для оказания Компании услуг, в частности по подтверждению принадлежности потребителю указанных им персональных данных, проверке точности и достоверности персональных данных, услуг по обработке обращений потребителей, в том числе по Горячей линии, и информационному взаимодействию с потребителем, по поддержке и обслуживанию информационных систем Компании и группы компаний JTI, услуг по курьерскому обслуживанию, услуг, предоставляемых аудиторскими, консультационными компаниями.</li>
                </ul>
              </p>
              <p class="sign-up-terms__text">
                С полным перечнем третьих лиц, которым передаются персональные данные можно ознакомиться по ссылке <a href="https://mevius.ru/contractors" target="_blank">https://mevius.ru/contractors</a>
              </p>
              <p class="sign-up-terms__text">
                Настоящее согласие действует до момента прекращения взаимодействия со мной, в том числе по моей инициативе. Настоящее согласие может быть отозвано мной в любое время одним из следующих способов: 1) направив письмо с указанием фамилии, имени, отчества и адреса, указанных при регистрации, на адрес электронной почты contact@jdata.ru, 2) в разделе «Личный кабинет» на сайте, где производилась регистрация, 3) направив письменный запрос в адрес Компании, указанный выше.
              </p>
              <p class="sign-up-terms__text">
                Я обязуюсь незамедлительно информировать, если предоставленные мной персональные данные утрачивают актуальность или изменяются.
              </p>
              <p class="sign-up-terms__text">
                Я согласен с тем, что предоставленные мной персональные данные будут удалены в случае отзыва согласия в течение 30 (тридцати) дней с даты получения отзыва согласия.
              </p>
              <p class="sign-up-terms__text">
                Я подтверждаю ознакомление с Политикой Конфиденциальности и принимаю ее условия.
              </p>
            </div>
          </div>
        </div>
        <div class="modal-info__button">
          <button class="button__blue button__lg" @click.prevent="closeModalPersonalData">
            Закрыть
          </button>
        </div>
      </div>
    </modal>

    <modal
      :show.sync="modalPrivacyPolicyOpened"
      class="modal-info modal-personal-data"
      @modal:close="closeModalPrivacyPolicy"
    >
      <div class="modal-info__wrapper">
        <div class="form-scroll">
          <div class="form-scroll__content" data-scroll-lock-scrollable ref="modalPrivacyPolicy">
            <div class="sign-up-terms">
              <p class="sign-up-terms__title">Политика о конфиденциальности</p>

<p class="sign-up-terms__text">
  Общество с ограниченной ответственностью «Дж.Т.И. Россия» (далее - Оператор, мы, наш, наши), ИНН 7703386329, зарегистрированное по адресу 123112, г. Москва, 1-й Красногвардейский проезд, д. 15, этажи 28-32, понимает, что Ваши персональные данные является одной из важнейших ценностей, поэтому придаёт большое значение защите Вашей частной жизни и безопасности Ваших данных.
</p>
<p class="sign-up-terms__text">
  Из настоящей Политики о конфиденциальности Вы узнаете, какие персональные данные мы собираем, зачем мы это делаем, как используем собранные данные, а также какие меры принимаем по обеспечению их безопасности для достижения заявленных нами целей обработки персональных данных, собираемых на сайте <a href="https://mevius.ru/" target="_blank">https://mevius.ru/</a>
</p>
<p class="sign-up-terms__text">
  Мы соблюдаем требования российского законодательства в области персональных данных. При обработке персональных данных мы придерживаемся принципов, изложенных в ст. 5 Федерального закона от 27.07.2006 г №152-ФЗ «О персональных данных» (далее – Закон о персональных данных).
</p>
<p class="sign-up-terms__text">
  Просим Вас внимательно изучить Политику о конфиденциальности (далее - Политика), чтобы понимать для чего мы собираем и обрабатываем Ваши персональные данные, а также какими правами Вы обладаете в отношении своих персональных данных, которые мы обрабатываем. Мы постарались сделать Политику максимально простой для Вашего понимания.
  Если у Вас возникли вопросы, пришлите нам электронное письмо на адрес электронной почты, указанный в разделе «Контакты».
</p>

<p class="sign-up-terms__subtitle">Термины</p>
<p class="sign-up-terms__text">
  Персональные данные – любая информация, относящаяся к прямо или косвенно определенному или определяемому физическому лицу (субъекту персональных данных);
</p>
<p class="sign-up-terms__text">
  Оператор персональных данных (оператор) – государственный орган, муниципальный орган, юридическое или физическое лицо, самостоятельно или совместно с другими лицами организующие и (или) осуществляющие обработку персональных данных, а также определяющие цели обработки персональных данных, состав персональных данных, подлежащих обработке, действия (операции), совершаемые с персональными данными;
</p>
<p class="sign-up-terms__text">
  Обработка персональных данных – любое действие (операция) или совокупность действий (операций) с персональными данными, совершаемых с использованием средств автоматизации или без их использования. Обработка персональных данных включает в себя, в том числе:
</p>

<ul>
  <li>сбор</li>
  <li>запись</li>
  <li>систематизацию</li>
  <li>накопление</li>
  <li>хранение</li>
  <li>уточнение (обновление, изменение)</li>
  <li>извлечение</li>
  <li>использование</li>
  <li>передачу (распространение, предоставление, доступ)</li>
  <li>обезличивание</li>
  <li>блокирование</li>
  <li>удаление</li>
  <li>уничтожение</li>
</ul>

<p class="sign-up-terms__text">
Автоматизированная обработка персональных данных – обработка персональных данных с помощью средств вычислительной техники;
</p>
<p class="sign-up-terms__text">
Распространение персональных данных – действия, направленные на раскрытие персональных данных неопределенному кругу лиц;
</p>
<p class="sign-up-terms__text">
Предоставление персональных данных – действия, направленные на раскрытие персональных данных определенному лицу или определенному кругу лиц;
</p>
<p class="sign-up-terms__text">
Блокирование персональных данных – временное прекращение обработки персональных данных (за исключением случаев, если обработка необходима для уточнения персональных данных);
</p>
<p class="sign-up-terms__text">
Уничтожение персональных данных – действия, в результате которых становится невозможным восстановить содержание персональных данных в информационной системе персональных данных и (или) в результате которых уничтожаются материальные носители персональных данных;
</p>
<p class="sign-up-terms__text">
Обезличивание персональных данных – действия, в результате которых становится невозможным без использования дополнительной информации определить принадлежность персональных данных конкретному субъекту персональных данных;
</p>
<p class="sign-up-terms__text">
Информационная система персональных данных – совокупность содержащихся в базах данных персональных данных и обеспечивающих их обработку информационных технологий и технических средств;
</p>
<p class="sign-up-terms__text">
Трансграничная передача персональных данных – передача персональных данных на территорию иностранного государства органу власти иностранного государства, иностранному физическому лицу или иностранному юридическому лицу.
</p>

<p class="sign-up-terms__subtitle">
1. Сфера применения
</p>
<p class="sign-up-terms__text">
Политика предназначена для информирования Вас о наших действиях по сбору, обработке и защите Ваших персональных данных для достижения нами заявленных целей обработки персональных данных, собираемых на сайте <a href="https://mevius.ru/" target="_blank">https://mevius.ru/</a> (далее – Сайт).
</p>
<p class="sign-up-terms__text">
Обратите внимание, что наш Сайт может содержать ссылки на ресурсы других поставщиков услуг, которые мы не контролируем и на которые не распространяется действие данной Политики.
</p>

<p class="sign-up-terms__subtitle">
2. Сбор персональных данных несовершеннолетних
</p>
<p class="sign-up-terms__text">
Наш Сайт не предназначен для обработки персональных данных несовершеннолетних лиц. Если у Вас есть основания полагать, что несовершеннолетнее лицо предоставило нам свои персональные данные, то просим Вас сообщить нам об этом, направив письмо по адресу, указанному в разделе «Контакты».
</p>

<p class="sign-up-terms__subtitle">
3. Для чего мы обрабатываем Ваши персональные данные
</p>
<p class="sign-up-terms__text">
Мы собираем, обрабатываем и раскрываем Ваши персональные данные только в конкретных и заранее определенных целях.
</p>
<p class="sign-up-terms__text">
На сайте осуществляется обработка Ваших персональных данных для достижения следующих целей:
</p>

<ul>
<li>
Развитие потребительского опыта при использовании продукции, взаимодействие с потребителями продукции, включая информирование пользователей продуктовых сайтов о деятельности и продукции Компании, проводимых активностях, что включает в себя:
</li>

<ul>
<li>
регистрацию и проверку предоставленных конечными потребителями данных для доступа на сайты о продукции и к участию в программах, мероприятиях и активностях;
</li>
<li>
составление статистической отчетности, аналитики данных об активностях потребителей для предоставления релевантной информации и повышения качества обслуживания, проведения опросов, исследований;
</li>
<li>
организацию работы «Горячей линии», сервисов «Обратной связи»;
</li>
<li>
взаимодействие с потребителями и направление информационных материалов о качественных характеристиках и потребительских свойствах продукции, программах, мероприятиях и активностях по любым каналам связи, включая, но не ограничиваясь,  направление смс-сообщений, сообщений по  электронной почте, передачу абонентам коротких текстовых сообщений, доступных для визуализации посредством использования программного обеспечения, установленного на их устройствах, в том числе всплывающих сообщений;
</li>
<li>
обработку обращений потребителей;
</li>
<li>
обеспечение работоспособности Сайта, в том числе с использованием информационных систем.
</li>
</ul>
</ul>

<p class="sign-up-terms__subheading">
  Ваши персональные данные, которые обрабатываются для указанной цели:
</p>

<ul>
<li>
фамилия, имя, отчество
</li>
<li>
пол
</li>
<li>
дата рождения
</li>
<li>
регион
</li>
<li>
паспортные данные или данные иного документа, удостоверяющего личность
</li>
<li>
контактная информация (адрес электронной почты, номера телефонов)
</li>
<li>
информация об используемых и предпочитаемых марках сигарет
</li>
<li>
информация по обращению и результатах его рассмотрения
</li>
<li>
данные, собираемые посредством метрических программ (функциональные файлы cookie)
</li>
<li>
данные, собираемые посредством метрических программ (аналитические файлы cookie)
</li>
</ul>

<p class="sign-up-terms__subheading">
Какие действия мы можем совершать с Вашими персональными данными:
</p>
<p class="sign-up-terms__text">
сбор, запись, систематизация, хранение, уточнение (обновление, изменение), извлечение, использование, передача (предоставление, доступ), блокирование, удаление, уничтожение.
</p>
<p class="sign-up-terms__text">
Обработка Ваших персональных данных осуществляется с использованием средств автоматизации и/или без использования таких средств.
</p>
<p class="sign-up-terms__text">
Основанием для обработки Ваших персональных данных является Ваше согласие на обработку персональных данных, предоставленное Вами при регистрации на Сайте или при обращении через Сайт, если иное не предусмотрено российским законодательством в области персональных данных.
</p>
<p class="sign-up-terms__text">
Мы будем обрабатывать Ваши персональные данные до момента прекращения взаимодействия с Вами, в том числе по Вашей инициативе.
</p>

<p class="sign-up-terms__subtitle">
4. Получатели персональных данных
</p>
<p class="sign-up-terms__text">
Мы можем передавать Ваши персональные данные третьим лицам, в том числе на территории иностранных государств, а также поручать им обработку Ваших персональных данных в объеме, необходимом для достижения цели, указанной в разделе 3 Политики. В частности, мы можем передавать Ваши персональные данные следующим третьим лицам:
</p>

<ul>
<li>
аффилированным лицам группы компаний JTI (в частности, головной компании JTI - JT International SA, (8, Рю Казем Раджави, 1202 Женева, Швейцария),
</li>
<li>
компаниям, оказывающим услуги веб-аналитики (метрические программы), в частности, сервис веб-аналитики Яндекс Метрика, предоставляемый компанией ООО «ЯНДЕКС», 119021, Россия, Москва, ул. Л. Толстого, 16,
</li>
<li>
компаниям, оказывающим услуги по поддержке и обслуживанию информационных систем Оператора и группы компаний JTI,
</li>
<li>
иным лицам, оказывающим услуги в случаях, когда такая передача персональных данных необходима для достижения целей, указанных в разделе 3 Политики.
</li>
</ul>

<p class="sign-up-terms__text">
Третьи лица, которые получают Ваши персональные данные от Оператора, обязаны сохранять конфиденциальность, не раскрывать третьим лицам и не распространять персональные данные без Вашего согласия.
</p>
<p class="sign-up-terms__text">

</p>
<p class="sign-up-terms__subtitle">
5. Ваши права и обязанности в отношении персональных данных
</p>
<p class="sign-up-terms__subheading">
5.1. Общая информация о Ваших правах
</p>
<p class="sign-up-terms__text">
Когда мы осуществляем обработку Ваших персональных данных, у вас есть множество прав, связанных с их обработкой, и вы можете реализовать эти права в любой момент. Ниже Вы можете ознакомиться с Вашими правами:
</p>

<ul>
<li>
<span class="sign-up-terms__first-line">право на доступ к персональным данным</span>
Вы можете получать доступ к своим персональным данным, запрашивать информацию о том, кто и как обрабатывает Ваши данные, поэтому мы предоставляем Вам соответствующую информацию в настоящей Политике.
</li>
<li>
<span class="sign-up-terms__first-line">право на уточнение персональных данных</span>
Вы можете вносить изменения и обновлять Ваши персональные данные в любое время.
</li>
<li>
<span class="sign-up-terms__first-line">право на блокирование и удаление персональных данных</span>
В определенных случаях у Вас есть право потребовать, чтобы мы удалили все Ваши данные. Если Вы решите удалить все персональные данные, уведомите нас об этом. Мы примем соответствующие действия, чтобы отреагировать на Ваш запрос в соответствии с требованиями российского законодательства.
</li>
<li>
<span class="sign-up-terms__first-line">право на обжалование наших действий или нашего бездействия</span>
Вы вправе возражать против определенных видов обработки данных, включая обработку в целях прямого маркетинга (например, получение от нас электронных сообщений или обращений, связанных с различными потенциальными возможностями). Вы вправе обжаловать действия или бездействие Оператора, нарушающие Ваши права и свободы, в уполномоченный орган по защите прав субъектов персональных данных или в судебном порядке.
</li>
<li>
<span class="sign-up-terms__first-line">право на возражение против решений, принятых на основании исключительно автоматизированной обработки их персональных данных</span>
Решение, порождающее юридические последствия в отношении Вас или иным образом затрагивающее Ваши права и законные интересы, может быть принято на основании исключительно автоматизированной обработки Ваших персональных данных только при наличии Вашего согласия в письменной форме или в случаях, предусмотренных федеральными законами, устанавливающими также меры по обеспечению соблюдения Ваших прав и законных интересов.
</li>
<li>
<span class="sign-up-terms__first-line">право на отзыв согласия</span>
Если Вы ранее дали согласие на обработку Ваших персональных, то Вы вправе в любое время отозвать его, обратившись к нам.
</li>
</ul>

<p class="sign-up-terms__text">
Далее мы более подробнее расскажем Вам о том, как вы можете реализовать Ваши права в отношении обработки персональных данных.
</p>
<p class="sign-up-terms__subheading">
5.2. Условия предоставления информации по Вашим правам
</p>
<p class="sign-up-terms__text">
Информация о способах обработки Ваших персональных данных предоставляется бесплатно. Мы можем отказать Вам в предоставлении информации, если Ваш запрос является явно необоснованным или чрезмерным, в частности из-за его повторяющегося характера.
</p>
<p class="sign-up-terms__subheading">
5.3. Право на доступ к Вашим персональным данным
</p>
<p class="sign-up-terms__text">
Вы имеете право получить от нас достоверную, полную информацию об обработке Ваших персональных данных в удобной для понимания форме, и, если это возможно, доступ к персональным данным и к следующей информации:
</p>

<ul>
<li>
подтверждение факта обработки персональных данных оператором;
</li>
<li>
правовые основания и цели обработки персональных данных;
</li>
<li>
цели и применяемые оператором способы обработки персональных данных;
</li>
<li>
наименование и место нахождения оператора, сведения о лицах (за исключением работников оператора), которые имеют доступ к персональным данным или которым могут быть раскрыты персональные данные на основании договора с оператором или на основании федерального закона;
</li>
<li>
обрабатываемые персональные данные, относящиеся к Вам, источник их получения;
</li>
<li>
сроки обработки персональных данных, в том числе сроки их хранения;
</li>
<li>
порядок осуществления Вами своих прав согласно Закону о персональных данных;
</li>
<li>
информацию об осуществленной или о предполагаемой трансграничной передаче данных;
</li>
<li>
наименование или фамилию, имя, отчество и адрес лица, осуществляющего обработку персональных данных по поручению оператора, если обработка поручена или будет поручена такому лицу;
</li>
<li>
информацию о способах исполнения оператором обязанностей, установленных статьей 18.1 Закона о персональных данных<sup>1</sup>;
</li>
<li>
иные сведения в соответствии с законодательством Российской Федерации.
</li>
</ul>

<p class="sign-up-terms__subheading">
5.4. Право на уточнение Ваших персональных данных
</p>
<p class="sign-up-terms__text">
Вы имеете право требовать вносить в них изменения и обновлять эти данные в любое время. Мы понимаем важность этого вопроса. Если вы хотите воспользоваться своим правом, обратитесь к нам, как это указано в п. 5.9.
</p>
<p class="sign-up-terms__subheading">
5.5. Право на блокирование и удаление Ваших персональных данных
</p>
<p class="sign-up-terms__text">
Вы имеете право требовать от нас блокирование и удаления Ваших персональных данных, которые мы обрабатываем. Если мы не можем удалить Ваши персональные данные, то мы вправе заблокировать их на срок до 6 месяцев и в этот срок найти решение по их удалению.
</p>
<p class="sign-up-terms__subheading">
5.6. Право на обжалование наших действий или нашего бездействия
</p>
<p class="sign-up-terms__text">
Вы имеете право возражать против обработки своих персональных данных в ответ на наши действия или наше бездействия. Для этого вы можете обратиться в территориальный орган Роскомнадзора в своем регионе или в суд.
</p>
<p class="sign-up-terms__subheading">
5.7. Право на возражение против решений, принятых на основании исключительно автоматизированной обработки персональных данных
</p>
<p class="sign-up-terms__text">
При принятии решений на основании исключительно автоматизированной обработки персональных данных, порождающих юридические последствия в отношении Вас или иным образом затрагивающих Ваши права и законные интересы мы разъясним Вам порядок принятия такого решения и возможные его юридические последствия, предоставим возможность заявить возражение против такого решения, а также разъясним порядок защиты Вами своих прав и законных интересов.
</p>
<p class="sign-up-terms__text">
Ваше возражение против решений на основании исключительно автоматизированной обработки персональных данных мы рассмотрим в течение тридцати дней со дня его получения и уведомим Вас о результатах рассмотрения такого возражения.
</p>
<p class="sign-up-terms__subheading">
5.8. Право на отзыв согласия
</p>
<p class="sign-up-terms__text">
Если Ваши данные обрабатываются на основании согласия, то вы имеете право отозвать его в любое время. В случае отзыва Вами согласия мы вправе продолжить обработку Ваших персональных данных при наличии иных оснований, предусмотренных российским законодательством в области персональных данных.
</p>
<p class="sign-up-terms__subheading">
5.9. Как Вы можете реализовать свои права?
</p>
<p class="sign-up-terms__text">
Вы можете написать свой запрос на наш адрес: 123112, г. Москва, 1-й Красногвардейский проезд, д. 15, этажи 28-32, указав в нем сведения о документе, удостоверяющем Вашу личность или личность Вашего представителя (вид документа, серия и номер, кем и когда выдан), Ваше ФИО (или ФИО представителя), информацию о взаимоотношениях с Вами, которые будут подтверждать факт обработки персональных данных нами, суть обращения, Вашу подпись (или подпись Вашего представителя).
</p>
<p class="sign-up-terms__text">
Запрос, направленный по электронной почте, будет признаваться документом, подписанным простой электронной подписью согласно российскому законодательству об электронной подписи.
</p>
<p class="sign-up-terms__text">
Вы можете получить дополнительную информацию о Ваших правах и соответствующие рекомендации, обратившись в Ваш территориальный орган Роскомнадзора.
</p>
<p class="sign-up-terms__subheading">
5.10. Как и когда мы можем не реализовать Ваши права
</p>
<p class="sign-up-terms__text">
Мы можем ограничить Ваше право на доступ к Вашим персональным данным в следующих случаях:
</p>

<ul>
<li>
обработка персональных данных, включая персональные данные, полученные в результате оперативно-розыскной, контрразведывательной и разведывательной деятельности, осуществляется в целях обороны страны, безопасности государства и охраны правопорядка;
</li>
<li>
обработка персональных данных осуществляется органами, осуществившими задержание субъекта персональных данных по подозрению в совершении преступления, либо предъявившими субъекту персональных данных обвинение по уголовному делу, либо применившими к субъекту персональных данных меру пресечения до предъявления обвинения, за исключением предусмотренных уголовно-процессуальным законодательством Российской Федерации случаев, если допускается ознакомление подозреваемого или обвиняемого с такими персональными данными;
</li>
<li>
обработка персональных данных осуществляется в соответствии с законодательством о противодействии легализации (отмыванию) доходов, полученных преступным путем, и финансированию терроризма;
</li>
<li>
доступ субъекта персональных данных к его персональным данным нарушает права и законные интересы третьих лиц;
</li>
<li>
обработка персональных данных осуществляется в случаях, предусмотренных законодательством Российской Федерации о транспортной безопасности, в целях обеспечения устойчивого и безопасного функционирования транспортного комплекса, защиты интересов личности, общества и государства в сфере транспортного комплекса от актов незаконного вмешательства.
</li>
</ul>

<p class="sign-up-terms__text">
Ваше право на блокирование и удаление не будет реализовано Оператором, когда мы будем иметь законные основания, предусмотренные российским законодательством в области персональных данных, для продолжения обработки Ваших персональных данных.
</p>
<p class="sign-up-terms__text">
Если мы не можем реализовать Ваше право по Вашему запросу, то мы напишем Вам мотивированный ответ.
</p>
<p class="sign-up-terms__subheading">
5.11. Ваши обязанности
</p>
<p class="sign-up-terms__text">
Являясь субъектом персональных данных, Вы обязаны предоставлять Оператору достоверные персональные данные и своевременно сообщать Оператору об изменениях и дополнениях своих персональных данных.
</p>
<p class="sign-up-terms__subtitle">
6. Использование файлов Cookie
</p>
<p class="sign-up-terms__text">
<strong>Файлы Cookie</strong> – это небольшой текстовый файл, который хранится на устройстве (компьютере, планшете, смартфоне и т.д.) и содержит информацию о Вашей активности в Интернете.
</p>
<p class="sign-up-terms__text">
<b>Файлы Cookie</b> являются одной из технологий, обеспечивающих нормальное функционирование любого сайта, и которые мы используем для автоматического сбора информации и улучшения качества контента.
</p>
<p class="sign-up-terms__text">
На нашем Сайте мы используем несколько видов cookies:
</p>

<ul>
<li>
<strong>Обязательные.</strong> Без таких cookie невозможна корректная работа сайта, они обязательны для использования всеми пользователями. Вы можете отключить их при помощи настроек своего браузера, при этом сайт или его компоненты будут работать некорректно.
</li>
<li>
<strong>Функциональные.</strong> Такие cookie помогают в осуществлении навигации по сайту, а также позволяет использовать функционал веб-страницы.
</li>
<li>
<strong>Аналитические.</strong> Такие cookie файлы используются для сбора статистических сведений о работе с сайтом. Если Вы хотите контролировать процесс установки файлов cookies, Вы можете установить в свой браузер специальные программы или дополнения, известные как инструменты запрета отслеживания, позволяющие Вам выбирать, какие файлы cookies Вы разрешаете хранить на своем устройстве.
</li>
</ul>

<p class="sign-up-terms__text">
На нашем Сайте также используется сервис веб-аналитики Яндекс.Метрика, чтобы помочь нам проанализировать, как именно Вы пользуетесь нашим Сайтом. Эта информация используется нами для улучшения работы Сайта. Данные веб-аналитики будут передаваться компании ООО «ЯНДЕКС», 119021, Россия, Москва, ул. Л. Толстого, 16 и храниться ею на серверах в России. Вы можете найти дополнительную информацию о Яндекс.Метрика на: <a href="https://yandex.ru/support/metrica/" target="_blank">https://yandex.ru/support/metrica/</a>.
</p>
<p class="sign-up-terms__text">
Заблокировать использование файлов cookies можно в настройках Вашего браузера. Однако в случае блокировки файлов cookies, это может повлиять на работу некоторых функций или разделов Сайта.
</p>
<p class="sign-up-terms__subtitle">
7. Безопасность данных
</p>
<p class="sign-up-terms__text">
Персональные данные, которые мы собираем и храним, считаются конфиденциальной информацией. Они защищены от потери, изменения, случайного или несанкционированного доступа, уничтожения, блокирования доступа и других несанкционированных действий согласно российскому законодательству в области персональных данных. Для этого мы применяем технические и организационные меры, предусмотренные российским законодательством в области защиты данных. Мы постоянно совершенствуем наши системы защиты данных.
</p>
<p class="sign-up-terms__text">
Принимая во внимание специфику пространства сети Интернет, мы не может гарантировать, что неуполномоченные третьи лица не смогут обойти меры зашиты, реализуемые нам, или использовать ваши данные в ненадлежащих целях, поскольку такие действия не зависят от принятых нами мер.
</p>
<p class="sign-up-terms__text">
Мы не несем ответственности за получение третьими лицами ваших персональных данных путем получения доступа к вашей учетной записи. Вы обязаны самостоятельно обеспечивать сохранность данных вашей учетной записи.
</p>
<p class="sign-up-terms__subtitle">
8. Изменение политики
</p>
<p class="sign-up-terms__text">
Мы оставляем за собой право вносить изменения в нашу Политику в любое время, поэтому мы опубликуем эти изменения (обновленную Политику) на Сайте, чтобы Вы всегда знали, как мы обрабатываем Ваши персональные данные. Мы просим Вас регулярно просматривать все обновления нашей Политики.
</p>
<p class="sign-up-terms__subtitle">
9. Контакты
</p>
<p class="sign-up-terms__text">
Обращаем Ваше внимание, что указанные в данном пункте контакты используются только для взаимодействия по вопросам обработки и защиты Ваших персональных данных. Обращения, направленные Вами по указанным в Политике контактам, не связанные с защитой данных, не будут рассмотрены. Для вопросов, связанных с обработкой и защитой персональных данных, Вы можете обратиться напрямую написав нам по адресу: 123112, г. Москва, 1-й Красногвардейский проезд, д. 15, этажи 28-32.
</p>
<div class="sign-up-terms__footnotes">
  <p class="sign-up-terms__footnote">
    <sup>1</sup> Указанная статья содержит перечень организационных, правовых и технических мер, которые должен предпринять оператор персональных данных для целей соблюдения требований Закона о персональных данных.
  </p>
</div>

            </div>
          </div>
        </div>
        <div class="modal-info__button">
          <button class="button__blue button__lg" @click.prevent="closeModalPrivacyPolicy">
            Закрыть
          </button>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
export default {
  model: {
    prop: 'value',
    event: 'change',
  },
  data() {
    return {
      modalPersonalDataOpened: false,
      modalPrivacyPolicyOpened: false
    }
  },
  props: {
    name: {
      type: String,
      required: true
    },
    value: {
      type: Boolean,
      default: null,
    },
    error: Boolean,
  },
  methods: {
    emitChange(checked) {
      this.$emit('change', checked);
    },
    openModalPrivacyPolicy() {
      this.modalPrivacyPolicyOpened = true;
    },
    closeModalPrivacyPolicy() {
      this.modalPrivacyPolicyOpened = false;
      this.$refs.modalPrivacyPolicy.scrollTop = 0;
    },
    openModalPersonalData() {
      this.modalPersonalDataOpened = true;
    },
    closeModalPersonalData() {
      this.modalPersonalDataOpened = false;
      this.$refs.modalPersonalData.scrollTop = 0;
    }
  }
}
</script>

<style lang="scss">
.modal-personal-data {
  .modal__body {
    margin-top: 15px;
  }
  .form-scroll {
    height: 50vh;
    margin-bottom: 15px;
  }
}
</style>
